import React, { memo } from "react";

const ContractIcon: React.FC = memo(() => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.21123 17.5831L10.7952 17.5831V11.9262H5.1383L5.1383 13.5101L8.06572 13.5243L5.1383 16.4517L6.26967 17.5831L9.19709 14.6557L9.21123 17.5831ZM13.5104 5.138L11.9265 5.138L11.9265 10.7949L17.5834 10.7949V9.21093L14.656 9.19679L17.5834 6.26937L16.452 5.138L13.5246 8.06542L13.5104 5.138Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { ContractIcon };
